import { render, staticRenderFns } from "./SVGMail.vue?vue&type=template&id=2f4e2fee&scoped=true&"
import script from "./SVGMail.vue?vue&type=script&lang=js&"
export * from "./SVGMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4e2fee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f4e2fee')) {
      api.createRecord('2f4e2fee', component.options)
    } else {
      api.reload('2f4e2fee', component.options)
    }
    module.hot.accept("./SVGMail.vue?vue&type=template&id=2f4e2fee&scoped=true&", function () {
      api.rerender('2f4e2fee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGMail.vue"
export default component.exports